import Entity from '../entity'

export default class Quiz extends Entity<number>{
    sale_id: number;
    dealer_id: number;
    customer: string;
    cellphone: string;
    email: string;
    suggestions: string;
    claims: string;
    claimed: boolean;

    responses: Array<any>;
}


